<template>
  <div
    :class="{ open: expanded }"
    class="accordion-container"
  >
    <div
      class="title"
      @click="toggle"
    >
      <span
        class="text"
        v-html="title"
      />
      <button>
        <icon
          :class="{ rotated: expanded }"
          name="cross"
          variant="white"
        />
      </button>
    </div>
    <div :class="['topic-content', { expanded }]">
      <slot />
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon.vue';

export default {
  components: { Icon },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  methods: {
    toggle() {
      this.$emit('accordion-toggled');
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-container {
  .title {
    border-top: 1px #e2e7ee solid;
    cursor: pointer;
    max-width: rem-calc(700);
    margin: auto;
    height: rem-calc(64);
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include breakpoint(small) {
      margin: auto rem-calc(16);
    }

    .text {
      font-size: rem-calc(16);
      @include font-color((
        mastery: black,
        standard: #354052
      ));
    }

    button {
      align-items: center;
      cursor: pointer;
      min-width: rem-calc(30);
      height: rem-calc(30);
      @include background-color($accent-1);
      border: none;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      padding: 0;

      > img {
        height: rem-calc(16);
        margin: auto;
        width: rem-calc(16);
        transform: rotate(45deg);

        &.rotated {
          transform: initial;
        }
      }
    }

  }
  .topic-content {
    height: 0;
    background-color: #f2f2f2;
    overflow: hidden;
    transition: all 180ms linear;
    opacity: 0;
    padding: 0 rem-calc(100);

    &.expanded {
      padding-bottom: rem-calc(32);
      padding-top: rem-calc(32);
      height: 80%;
      opacity: 1;
    }

    @include breakpoint(small) {
      padding: 0 rem-calc(16);
    }

    > * {
      margin-left: auto;
      margin-right: auto;
      max-width: rem-calc(700);
    }
  }
}
</style>
